/**
 * @desc 获取Oil列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<Array<defs.Oil>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrol/findPetrolList',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
